// API Configuration
// URLs are loaded from environment variables (.env files)
// Set REACT_APP_API_URL and REACT_APP_WS_URL in .env.local for local development
// Default is '/api' (relative) so the same build works on any server via nginx proxy.
// See nginx.conf: location /api/ { proxy_pass http://127.0.0.1:3001/api/; }
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
// Empty string means "use window.location.origin" (same-server WebSocket)
const WS_URL = process.env.REACT_APP_WS_URL || '';
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID || '';
const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI || '';
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || '';

export const config = {
  apiBaseUrl: API_BASE_URL,
  wsUrl: WS_URL,  // Empty string = use window.location.origin in websocket.js
  tokenKey: 'studioaeye_token',
  refreshThreshold: 5 * 60 * 1000, // 5 minutes before expiry
  push: {
    vapidPublicKey: VAPID_PUBLIC_KEY,
  },
  oauth: {
    googleClientId: GOOGLE_CLIENT_ID,
    appleClientId: APPLE_CLIENT_ID,
    appleRedirectUri: APPLE_REDIRECT_URI,
  },
};

export default config;
